/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyBaseVo from './CompanyBaseVo';
import TextbookVersionVo from './TextbookVersionVo';




  /**
   * The TextBookWithLatestVersionVo model module.
   * @module textbook/model/TextBookWithLatestVersionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookWithLatestVersionVo</code>.
   * @alias module:textbook/model/TextBookWithLatestVersionVo
   * @class
   */
  var exports = function() {
    var _this = this;

























  };

  /**
   * Constructs a <code>TextBookWithLatestVersionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookWithLatestVersionVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookWithLatestVersionVo} The populated <code>TextBookWithLatestVersionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'infoUrl')) {
        obj['infoUrl'] = ApiClient.convertToType(data['infoUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'versionNum')) {
        obj['versionNum'] = ApiClient.convertToType(data['versionNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'chiefEditor')) {
        obj['chiefEditor'] = ApiClient.convertToType(data['chiefEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'deputyEditor')) {
        obj['deputyEditor'] = ApiClient.convertToType(data['deputyEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contributingAuthors')) {
        obj['contributingAuthors'] = ApiClient.convertToType(data['contributingAuthors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producer')) {
        obj['producer'] = ApiClient.convertToType(data['producer'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompanyId')) {
        obj['producerCompanyId'] = ApiClient.convertToType(data['producerCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompany')) {
        obj['producerCompany'] = CompanyBaseVo.constructFromObject(data['producerCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contactInfo')) {
        obj['contactInfo'] = ApiClient.convertToType(data['contactInfo'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'edition')) {
        obj['edition'] = ApiClient.convertToType(data['edition'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'copyrightStatement')) {
        obj['copyrightStatement'] = ApiClient.convertToType(data['copyrightStatement'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'latestVersion')) {
        obj['latestVersion'] = TextbookVersionVo.constructFromObject(data['latestVersion']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompany')) {
        obj['publisherCompany'] = CompanyBaseVo.constructFromObject(data['publisherCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookFormat')) {
        obj['bookFormat'] = ApiClient.convertToType(data['bookFormat'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'forSale')) {
        obj['forSale'] = ApiClient.convertToType(data['forSale'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'aiTextbook')) {
        obj['aiTextbook'] = ApiClient.convertToType(data['aiTextbook'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'standardType')) {
        obj['standardType'] = ApiClient.convertToType(data['standardType'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 封面
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 简介
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 教材简介url
   * @member {String} infoUrl
   */
  exports.prototype['infoUrl'] = undefined;
  /**
   * 压缩包版本号，用于升级
   * @member {String} versionNum
   */
  exports.prototype['versionNum'] = undefined;
  /**
   * 0待发布；1上线；2下线
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 主编
   * @member {String} chiefEditor
   */
  exports.prototype['chiefEditor'] = undefined;
  /**
   * 副主编
   * @member {String} deputyEditor
   */
  exports.prototype['deputyEditor'] = undefined;
  /**
   * 参编人员
   * @member {String} contributingAuthors
   */
  exports.prototype['contributingAuthors'] = undefined;
  /**
   * 制作单位
   * @member {String} producer
   */
  exports.prototype['producer'] = undefined;
  /**
   * 制作单位id
   * @member {Integer} producerCompanyId
   */
  exports.prototype['producerCompanyId'] = undefined;
  /**
   * 制作单位
   * @member {module:textbook/model/CompanyBaseVo} producerCompany
   */
  exports.prototype['producerCompany'] = undefined;
  /**
   * 教材联系
   * @member {String} contactInfo
   */
  exports.prototype['contactInfo'] = undefined;
  /**
   * 版次
   * @member {String} edition
   */
  exports.prototype['edition'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;
  /**
   * 版权声明
   * @member {String} copyrightStatement
   */
  exports.prototype['copyrightStatement'] = undefined;
  /**
   * 最新版本
   * @member {module:textbook/model/TextbookVersionVo} latestVersion
   */
  exports.prototype['latestVersion'] = undefined;
  /**
   * 出版社
   * @member {module:textbook/model/CompanyBaseVo} publisherCompany
   */
  exports.prototype['publisherCompany'] = undefined;
  /**
   * 电子书格式 0:App 100:自建H5 101:第三方H5 200:pdf
   * @member {Integer} bookFormat
   */
  exports.prototype['bookFormat'] = undefined;
  /**
   * 排序键（数字越小越靠前）
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 是否开放销售
   * @member {Boolean} forSale
   */
  exports.prototype['forSale'] = undefined;
  /**
   * 是否AI教材
   * @member {Boolean} aiTextbook
   */
  exports.prototype['aiTextbook'] = undefined;
  /**
   * 规划教材类型 0:无 1:国规 2:省规
   * @member {Integer} standardType
   */
  exports.prototype['standardType'] = undefined;



  export default exports;
;


